import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getMetodologiasEmpleadas, postMetodologiaEmpleada } from "../../../../../../../../redux/actions/resolucion";
import MetodologiaForm from "./MetodologiaForm";


const initialValues = {
    idTipoEstudio: "",
    nombreTiposEstudio: "",
    descripcion: "",
}

const MetodologiaFormContainer = ({ values, open, handleClose, setFieldValue, metodologiasEmpleadas }) => {
    const dispatch = useDispatch();
    const [formInitialValues, setFormInitialValues] = useState();

    useEffect(() => {
        if (values) setFormInitialValues({
            idTipoEstudio: values.idTipoEstudio,
            nombreTiposEstudio: values.nombreTiposEstudio,
            descripcion: "",
        });
        else {
            setFormInitialValues(initialValues)
        }
    }, [values])

    const handleSubmit = (values) => {
        const { nombreTiposEstudio, ...postValues } = values;
        dispatch(postMetodologiaEmpleada(postValues)).then(() => {
            dispatch(getMetodologiasEmpleadas(values.idTipoEstudio)).then((res) => {
                setFieldValue(
                    'idMetodologiaEmpleada',
                    res?.value?.data?.find((estudio) => estudio.nombre === values.descripcion)?.id
                );
            })
            handleClose();
        })

    }

    return <MetodologiaForm
        open={open}
        values={formInitialValues}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        metodologiasEmpleadas={metodologiasEmpleadas}

    />
}

export default MetodologiaFormContainer;